import styled from 'styled-components';

export const WhyMyPartnerMainWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        padding: ${props.theme.spacing.large.l40} 0;
        @media only screen and (min-width:320px) and (max-width: 991px){
            margin-bottom: ${props.theme.spacing.large.l20};
        }    
    `
);

export const WhyMypartnerOuterWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        max-width:80%;
        margin:0 auto;

        @media only screen and (min-width:320px) and (max-width: 1300px){
            max-width:100%;
        }      
    `
);

export const WhyMypartnerInnerWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        flex-direction: column;
        align-items: center;
    `
);

export const WhyMypartnerHeadWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        align-items: center;
        flex-direction: column;
        padding-bottom: ${props.theme.spacing.large.l40};

        @media only screen and (min-width:320px) and (max-width: 991px){
            padding: 0 ${props.theme.spacing.large.l25} ${props.theme.spacing.large.l15};
            align-items: flex-start;
        }   
    `
);

export const WhyMypartnerHeadText = styled.h2(
    props => `
        font-size: ${props.theme.font.large.font35};
        color: ${props.theme.colors.black.base1};
        font-weight: ${props.theme.font.fontWeight.black};

        @media only screen and (min-width:320px) and (max-width: 991px){
            font-size: ${props.theme.font.large.font18};
        }   
    `
);

export const WhyMypartnerSubText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font18};
        color: ${props.theme.colors.grey.dark3};
        line-height: 1.33;

        @media only screen and (min-width:320px) and (max-width: 991px){
            font-size: ${props.theme.font.base};
        } 
    `
);

export const WhyMyPartnerBenifitWrap = styled.div(
    props => `
        width: 100%;
        display: flex;
        margin-top: ${props.theme.spacing.small.s5};
        flex-direction: column;
    `
);

export const BenifitInnerWrap = styled.div(
    props => `
        width:100%;
        max-width:90%;
        display: flex;
        align-items: center;
        margin: 0 auto;
        padding-bottom: ${props.theme.spacing.large.l20};
        justify-content: center;

        @media only screen and (min-width:320px) and (max-width: 991px){
            max-width:100%;
            padding: 0 ${props.theme.spacing.small.s8};
            flex-direction: column;
        }
        @media only screen and (min-width:992px) and (max-width: 1300px){
            max-width:95%;
        }
    `
);

export const BenifitCardWrap = styled.div(
    props => `
        display: flex;
        width:40%;
        border-radius: 1.5rem;
        box-shadow: 0 0 77px 0 rgba(0, 0, 0, 0.06);
        background-color: ${props.theme.colors.white.base};
        padding: ${props.theme.spacing.large.l35};
        align-items: center;
        margin-right: ${props.theme.spacing.large.l20};

        @media only screen and (min-width:320px) and (max-width: 991px){
            width:100%;
            padding: ${props.theme.spacing.large.l15};
            margin-right: 0;
            margin-bottom: ${props.theme.spacing.base};
        }

        @media only screen and (min-width:992px) and (max-width: 1300px){
            width:50%
        }
    `
);

export const BenifitIconWrap = styled.div(
    props => `
        width: 4.4rem;
        height: 4.4rem;
        margin-right: ${props.theme.spacing.base};
    `
);

export const BenifitTextWrap = styled.div(
    props => `
        display: flex;
        flex-direction: column;
    `
);

export const BenifitHeadText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font16};
        color: ${props.theme.colors.blue.dark};
        font-weight: ${props.theme.font.fontWeight.black};
        line-height: 1.25;
        text-transform: uppercase;

        @media only screen and (min-width:320px) and (max-width: 991px){
            font-size: ${props.theme.font.large.font14};
        }
    `
);

export const BenifitSubText = styled.div(
    props => `
        font-size: ${props.theme.font.large.font16};
        color: ${props.theme.colors.grey.base};

        @media only screen and (min-width:320px) and (max-width: 991px){
            font-size: ${props.theme.font.large.font14};
        }
    `
)